// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";

import { useInterval } from "../../hooks/useInterval";
import SPSnackbar from "./SPSnackbar";

export const LoadingOverlay = ({ fullscreen, message, timeout }) => {
  const style = {
    position: fullscreen ? "fixed" : "absolute",
    top: 0,
    left: 0,
    background: "rgba(0,0,0,0.6)",
    zIndex: 999,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };
  const [percent, setPercent] = useState(0);

  useInterval(() => {
    setPercent(percent + 10);
  }, 1200);

  const handleClose = () => {
    setPercent(timeout);
  };
  return (
    <div style={style} data-testid="loading-overlay">
      <CircularProgress color="inherit" size={200} />
      {fullscreen && (
        <div
          style={{
            width: 500,
            maxWidth: "75%",
            height: 30,
            marginTop: 35,
            borderRadius: 20,
            border: "3px solid white",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${percent}%`,
              height: "100%",
              background: "#e2231a",
            }}
          />
          <SPSnackbar
            handleClose={handleClose}
            message={message}
            open={percent > 200 && percent < 300}
          />
        </div>
      )}
    </div>
  );
};

LoadingOverlay.propTypes = {
  fullscreen: PropTypes.bool,
  timeout: PropTypes.number,
  message: PropTypes.string,
};

LoadingOverlay.defaultProps = {
  fullscreen: true,
  timeout: 500,
  message: "General.GenericError",
};
